export default __webpack_public_path__ + "assets/bd83364721342575698476aff6b0beab.jpg";